import httpService from './http.service';
import { API_URLS } from '../config/constants';

export interface GoogleAdsPriceTier {
  label: string;
  cpcBidMicros: number;
  criterionResourceName?: string;
}

export interface GoogleAdsCampaign {
  _id: string;
  name: string;
  budgetMicros: number;
  status: 'created' | 'error';
  error?: string;
  campaignResourceName?: string;
  adGroupResourceName?: string;
  priceTiers: GoogleAdsPriceTier[];
  createdAt: string;
}

export interface CreateGoogleAdsCampaignPayload {
  name: string;
  dailyBudgetUah: number;
  priceTiers: { label: string; cpcBidUah: number }[];
}

export const getGoogleAdsCampaigns = () => httpService.get<GoogleAdsCampaign[]>(API_URLS.GOOGLE_ADS.LIST);

export const createGoogleAdsCampaign = (data: CreateGoogleAdsCampaignPayload) => httpService.post<GoogleAdsCampaign>(API_URLS.GOOGLE_ADS.CREATE, data);
